import GetPostResponse from 'Global/Functions/GetPostResponse/GetPostResponse';
import { env } from 'env';

export const GetWordsList = (
  SearchQuery = '',
  forceRender,
  lang
) => {
  console.log('LanguageEditor--->', lang);

  const wordList = GetPostResponse(
    `${process.env.REACT_APP_API_URL_API_LIST_LOCALIZATION_LANGUAGE}`,
    true,
    {
      DistinitationLanguage: lang,
      SearchKey: SearchQuery,
      TopRecord: '200',
    },
    forceRender
  )?.Data;
  return wordList?.map((word) => ({
    ...word,
  }));
};
